import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Divider } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import MerchantBasicDetail from "./MerchantComponents/MerchantBasicDetail";

import { useGetMerchantDetailQuery } from "store/services/merchantApi";

import {
  MerchantDetailContext,
  useMerchantDetailContext,
} from "contexts/MerchantDetailContext";
import MerchantDetailTab from "./MerchantComponents/MerchantDetailTab";

const MerchantDetailScreen = () => {
  const { id } = useParams();

  const breadcrumbs = [
    { title: "Merchants", path: "/app/crm/merchant/list" },
    { title: "Merchant Detail" },
  ];

  // RTK Query
  const {
    data: merchantDetail,
    isLoading: loadingMerchant,
    error,
  } = useGetMerchantDetailQuery(id);

  return (
    <MerchantDetailContext.Provider
      value={{ merchantDetail, loadingMerchant }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingMerchant}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <MerchantBasicDetail />
          <Divider />
          <MerchantDetailTab />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </MerchantDetailContext.Provider>
  );
};

export default MerchantDetailScreen;

const PageActions = () => {
  const { merchantDetail } = useMerchantDetailContext();
  return (
    <div className="flex items-center gap-4">
      <Link to={`/app/crm/merchant/${merchantDetail?._id}/edit`}>
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};